<style scoped>
.input-group .v-select{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}
</style>
<script>
import { notify } from '@/helpers/notify' 
import { kimlikData }  from "../../data"
import Loader from "@/components/widgets/loader.vue"; 
import Iletisim from "./update_iletisim.vue"

export default {
    name: 'UpdateModal',
    props:[
      "subs"
    ],
    data() {
        return {
            form: {},
            customer:{},
            contact:{},
            idDetail:{},
            submitted: false,
            kimlikData,
            dataLoading:true,
            loadButton:false,
            kimlikOpen:true,
            iletisimOpen:true,
            editing:'',
            subsId:0
        };
    },
    components: {
      Loader,
      Iletisim
    },
    computed:{
      kayitliOldugu(){
        const kayitli = [ 'TCKK','TCPC','TCPL','TCPY','TCPG','TCPK','TCGP','YP','TCSC','TCYK','TCMA' ];
        return !kayitli.includes(this.customer.kimlik_tipi)
      }
    },
    watch:{
      subs(prop){
          
          this.$http.post("query" , { subsId : prop } )
              .then(res => {
                  this.subsId = res.data.content.customer.id
                  this.customer = res.data.content.customer
                  this.contact = res.data.content.address
                  this.idDetail = res.data.content.idDetail
                  this.dataLoading = false
              })
      }
    },
    methods: {
        handleEditing(value){
          this.editing=value
        },
        update(name) {
            if(this.loadButton) return
            
            this.submitted = true;
            this.loadButton = true

            const data = name.split('.')

            this.$http.put(`members/update`, { key:name, value:this[data[0]][data[1]], id:this.subsId} )
            .then((resp) => {  
              this.loadButton = false;
              notify.success(resp.data.message) 
            })
          
          this.submitted = false;
        },
        close(){
          this.$bvModal.hide('update_model')
        },
       
    },
};
</script>

<template>
<b-modal id="update_model" size="xl" title="Müşteri Detay Güncelle"  no-close-on-backdrop hide-footer>
    <Loader :loading="true" :load="dataLoading">
            <div class="row">
                <div class="col-md-4">
                    <label for="type">Abone Tipi</label>
                    <div class="mb-3">
                      <span v-if="editing == 'customer.type'">
                        <div class="input-group">
                          <select v-model="customer.type" class="form-control form-select" v-if="editing == 'customer.type'">
                            <option value="b">Bireysel</option>
                            <option value="k">Kurumsal</option>
                        </select>
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.type'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                        </span>
                        <span v-else>
                            {{ customer.type == 'b' ? 'Bireysel' : 'Kurumsal'}}  
                            <span class="float-end">
                              <a href="#" @click.prevent="editing = 'customer.type'">
                                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                              </a>
                          </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row" v-if="customer.type == 'k'">
                <div class="col-md-4">
                  <label for="musteri_tipi">Kurum Tipi</label>
                  <div class="mb-3">
                    <span v-if="editing == 'customer.musteri_tipi'">
                      <div class="input-group">
                        <select v-model="customer.musteri_tipi" class="form-control form-select">
                            <option value="G-SIRKET">Şahıs Şirketi</option>
                            <option value="T-SIRKET">Diğer Şirket</option>
                            <option value="T-KAMU">Kamu Kuruluşu</option>
                        </select>
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.musteri_tipi'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                      </span>
                      <span v-else>
                          {{ customer.musteri_tipi }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'customer.musteri_tipi'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                  </div>
                </div>
                <div class="col-md-4">
                    <label for="identity_num">Vergi Dairesi</label>
                    <div class="mb-3">
                      <span v-if="editing == 'customer.taxoffice'">
                        <div class="input-group">
                          <input
                            id="identity_num"
                            v-model="customer.taxoffice"
                            type="text"
                            class="form-control"
                            placeholder="Vergi Dairesi"
                          />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.taxoffice'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                        </span>
                        <span v-else>
                            {{ customer.taxoffice }} 
                            <span class="float-end">
                              <a href="#" @click.prevent="editing = 'customer.taxoffice'">
                                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                              </a>
                          </span>
                        </span>
                    </div>
                </div>
                <div class="col-md-4">
                    <label for="taxnum">Vergi Numarası</label>
                    <div class="mb-3">
                      <span v-if="editing == 'customer.taxnum'">
                        <div class="input-group">
                          <input
                            id="taxnum"
                            v-model="customer.taxnum"
                            type="text"
                            class="form-control"
                            placeholder="Vergi Numarası"
                          />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.taxnum'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ customer.taxnum }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'customer.taxnum'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <label for="companyname">Firma Ünvan</label>
                  <div class="mb-3">
                      <span v-if="editing == 'customer.companyname'">
                        <div class="input-group">
                          <input
                            id="companyname"
                            v-model="customer.companyname"
                            type="text"
                            class="form-control"
                            placeholder="Firma Ünvan"
                          />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.companyname'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ customer.companyname }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'customer.companyname'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label for="kimlik_tipi">Kimlik Tipi</label>
                    <div class="mb-3">
                      <span v-if="editing == 'customer.kimlik_tipi'">
                        <div class="input-group">
                          <v-select  
                            id="kimlik_tipi"
                            v-model="customer.kimlik_tipi" 
                            :options="kimlikData"
                            :reduce="resp=> resp.kod"
                            label="title"/>
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.kimlik_tipi'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ customer.kimlik_tipi }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'customer.kimlik_tipi'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="tc">Kimlik Numarası</label>
                  <div class="mb-3">
                    <span v-if="editing == 'customer.tc'">
                      <div class="input-group">
                       <input
                            id="tc"
                            v-model="customer.tc"
                            type="text"
                            class="form-control"
                            placeholder="Kimlik Numarası"
                        />
                        <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.tc'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                        <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                      </div>
                    </span>
                    <span v-else>
                        {{ customer.tc }} 
                        <span class="float-end">
                          <a href="#" @click.prevent="editing = 'customer.tc'">
                              <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                          </a>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label for="seri_no">Kimlik Seri No</label>
                    <div class="mb-3">
                      <span v-if="editing == 'customer.seri_no'">
                        <div class="input-group">
                          <input
                              id="seri_no"
                              v-model="customer.seri_no"
                              type="text"
                              class="form-control"
                              placeholder="Kimlik Seri No"
                          />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.seri_no'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ customer.seri_no }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'customer.seri_no'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                 </div>
              </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="fname">İsim</label>
                        <div class="mb-3">
                          <span v-if="editing == 'customer.fname'">
                            <div class="input-group">
                              <input
                                  id="fname"
                                  v-model="customer.fname"
                                  type="text"
                                  class="form-control"
                                  placeholder="İsim"
                              />
                              <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.fname'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                              <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                          </span>
                          <span v-else>
                              {{ customer.fname }} 
                              <span class="float-end">
                                <a href="#" @click.prevent="editing = 'customer.fname'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                          </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="lname">Soyisim</label>
                         <div class="mb-3">
                          <span v-if="editing == 'customer.lname'">
                            <div class="input-group">
                             <input
                                  id="lname"
                                  v-model="customer.lname"
                                  type="text"
                                  class="form-control"
                                  placeholder="Soyisim"
                              />
                              <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.lname'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                              <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                            </div>
                          </span>
                          <span v-else>
                              {{ customer.lname }} 
                              <span class="float-end">
                                <a href="#" @click.prevent="editing = 'customer.lname'">
                                    <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                                </a>
                            </span>
                          </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                      <label for="bday">Doğum Tarihi</label>
                      <div class="mb-3">
                        <span v-if="editing == 'customer.bday'">
                          <div class="input-group">
                            <input
                                id="bday"
                                v-model="customer.bday"
                                type="date"
                                class="form-control" 
                            />
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('customer.bday'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                          </div>
                        </span>
                        <span v-else>
                            {{ customer.bday }} 
                            <span class="float-end">
                              <a href="#" @click.prevent="editing = 'customer.bday'">
                                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                              </a>
                          </span>
                        </span>
                      </div>
                    </div>
                </div>

        <div class="row">
          <div class="card px-0 py-0 my-0">
            <div class="card-header" @click="kimlikOpen=!kimlikOpen">
              <h5 class="card-title my-0">Kimlik Bilgileri <span class="float-end"><i class="fa fa-chevron-down"></i></span></h5>
            </div>
            <div class="card-body" v-if="kimlikOpen">
              <div class="row">
                  <div class="col-md-3">
                    <label for="gender">Cinsiyet</label>
                    <div class="mb-3">
                      <span v-if="editing == 'idDetail.gender'">
                        <div class="input-group">
                          <select 
                              id="gender"
                              v-model="idDetail.gender" 
                              class="form-control form-select"
                              >
                              <option value="K">Kadın</option>
                              <option value="E">Erkek</option>
                          </select>
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.gender'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ idDetail.gender == 'E' ? 'Erkek' : 'Kadın'}} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'idDetail.gender'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="nationality">Uyruk</label>
                    <div class="mb-3">
                      <span v-if="editing == 'idDetail.nationality'">
                        <div class="input-group">
                           <select 
                              v-model="idDetail.nationality" 
                              class="form-control form-select"
                              >
                              <option value="TUR">Türkiye</option>
                          </select>
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.nationality'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ idDetail.nationality }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'idDetail.nationality'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="bplace">Doğum Yeri</label>
                    <div class="mb-3">
                      <span v-if="editing == 'idDetail.bplace'">
                        <div class="input-group">
                              <input
                              id="bplace"
                              v-model="idDetail.bplace"
                              type="text"
                              class="form-control"
                              placeholder="Doğum Yeri"
                              />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.bplace'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ idDetail.bplace }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'idDetail.bplace'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                 </div>
              </div>
              <div class="row" v-if="kayitliOldugu">
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_verildigi_yer">Kimliğin Verildiği Yer</label>
                          <input
                          id="kimlik_verildigi_yer"
                          v-model="idDetail.kimlik_verildigi_yer"
                          type="text"
                          class="form-control"
                          placeholder="Kimliğin Verildiği Yer"
                          />
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_sayfa_no">Sayfa/Sıra No</label>
                          <input
                          id="kimlik_sayfa_no"
                          v-model="idDetail.kimlik_sayfa_no"
                          type="text"
                          class="form-control"
                          placeholder="Sayfa/Sıra No"
                          
                          :class="{
                              'is-invalid': submitted && $v.idDetail.kimlik_sayfa_no.$error,
                          }"
                          />
                          <div
                          v-if="submitted && $v.idDetail.kimlik_sayfa_no.$error"
                          class="invalid-feedback"
                          >
                          <span v-if="!$v.idDetail.kimlik_sayfa_no.required"
                              >Bu alanı doldurmak zorunludur.</span
                          >
                          </div>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="Kimlik Cilt No">Kimlik Cilt No</label>
                          <input
                          id="Kimlik Cilt No"
                          v-model="idDetail.kimlik_cilt_no"
                          type="text"
                          class="form-control"
                          placeholder="Kimlik Cilt No"
                          
                          :class="{
                              'is-invalid': submitted && $v.idDetail.kimlik_cilt_no.$error,
                          }"
                          />
                          <div
                          v-if="submitted && $v.idDetail.kimlik_cilt_no.$error"
                          class="invalid-feedback"
                          >
                          <span v-if="!$v.idDetail.kimlik_cilt_no.required"
                              >Bu alanı doldurmak zorunludur.</span
                          >
                          </div>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_kutuk_no">Kütük/Aile Sıra No</label>
                          <input
                          id="kimlik_kutuk_no"
                          v-model="idDetail.kimlik_kutuk_no"
                          type="text"
                          class="form-control"
                          placeholder="Kütük/Aile Sıra No"
                          />
                      </div>
                  </div> 
              </div>
              <div class="row" v-if="kayitliOldugu">
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_il">Kayıtlı Olduğu İl</label>
                          <input
                          id="kimlik_il"
                          v-model="idDetail.kimlik_il"
                          type="text"
                          class="form-control"
                          placeholder="Kayıtlı Olduğu İl"
                          
                          :class="{
                              'is-invalid': submitted && $v.idDetail.kimlik_il.$error,
                          }"
                          />
                          <div
                          v-if="submitted && $v.idDetail.kimlik_il.$error"
                          class="invalid-feedback"
                          >
                          <span v-if="!$v.idDetail.kimlik_il.required"
                              >Bu alanı doldurmak zorunludur.</span
                          >
                          </div>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_ilce">Kayıtlı Olduğu İlçe</label>
                          <input
                          id="kimlik_ilce"
                          v-model="idDetail.kimlik_ilce"
                          type="text"
                          class="form-control"
                          placeholder="Baba Adı"
                          
                          :class="{
                              'is-invalid': submitted && $v.idDetail.kimlik_ilce.$error,
                          }"
                          />
                          <div
                          v-if="submitted && $v.idDetail.kimlik_ilce.$error"
                          class="invalid-feedback"
                          >
                          <span v-if="!$v.idDetail.kimlik_ilce.required"
                              >Bu alanı doldurmak zorunludur.</span
                          >
                          </div>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="mb-3">
                          <label for="kimlik_mahalle">Kayıtlı Olduğu Mahalle</label>
                          <input
                          id="kimlik_mahalle"
                          v-model="idDetail.kimlik_mahalle"
                          type="text"
                          class="form-control"
                          placeholder="Kayıtlı Olduğu Mahalle"
                          
                          :class="{
                              'is-invalid': submitted && $v.idDetail.kimlik_mahalle.$error,
                          }"
                          />
                          <div
                          v-if="submitted && $v.idDetail.kimlik_mahalle.$error"
                          class="invalid-feedback"
                          >
                          <span v-if="!$v.idDetail.kimlik_mahalle.required"
                              >Bu alanı doldurmak zorunludur.</span
                          >
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-3">
                    <label for="mmaiden_name">Anne Kızlık Soyadı</label>
                     <div class="mb-3">
                      <span v-if="editing == 'idDetail.mmaiden_name'">
                        <div class="input-group">
                          <input
                            id="mmaiden_name"
                            v-model="idDetail.mmaiden_name"
                            type="text"
                            class="form-control"
                            placeholder="Anne Kızlık Soyadı"
                            />
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.mmaiden_name'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ idDetail.mmaiden_name }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'idDetail.mmaiden_name'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                      <label for="mothername">Anne Adı</label>
                      <div class="mb-3">
                        <span v-if="editing == 'idDetail.mothername'">
                          <div class="input-group">
                            <input
                              id="mothername"
                              v-model="idDetail.mothername"
                              type="text"
                              class="form-control"
                              placeholder="Anne Adı"
                            />
                          
                            <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.mothername'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                            <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                          </div>
                        </span>
                        <span v-else>
                            {{ idDetail.mothername }} 
                            <span class="float-end">
                              <a href="#" @click.prevent="editing = 'idDetail.mothername'">
                                  <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                              </a>
                          </span>
                        </span>
                      </div>
                    </div>
                  <div class="col-md-3">
                    <label for="fathername">Baba Adı</label>
                    <div class="mb-3">
                      <span v-if="editing == 'idDetail.fathername'">
                        <div class="input-group">
                            <input
                              id="fathername"
                              v-model="idDetail.fathername"
                              type="text"
                              class="form-control"
                              placeholder="Baba Adı"
                              />
                        
                          <button class="btn btn-success btn-sm" type="button" @click.prevent="update('idDetail.fathername'),editing= ''"> <i class="mdi mdi-check"></i> </button>
                          <button class="btn btn-danger btn-sm" type="button" @click.prevent="editing = ''"> <i class="mdi mdi-close"></i> </button>
                        </div>
                      </span>
                      <span v-else>
                          {{ idDetail.fathername }} 
                          <span class="float-end">
                            <a href="#" @click.prevent="editing = 'idDetail.fathername'">
                                <i class="mdi mdi-circle-edit-outline text-success font-size-16"></i>
                            </a>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>    
          <Iletisim 
            :data="contact"
            :id="subsId"
            :editingTriger="editing"
            @editing="handleEditing"
          />
     </Loader>
    </b-modal>
</template>